<template>
  <small-modal
    :title="modalTitle"
    class="product-properties-modal"
    :fit-content="true"
    @close="close"
  >
    <h2 class="subtitle">
      {{ $t("productPages.productPropertiesModal.subtitle") }}
    </h2>
    <div class="props-table">
      <!-- Name -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.name") }}
        </div>
        <div class="prop-value">
          {{ product?.name || "—" }}
        </div>
      </div>

      <!-- Product ID -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.productId") }}
        </div>
        <div class="prop-value">
          {{ product?._id || "—" }}
        </div>
      </div>

      <!-- Brand -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.brand") }}
        </div>
        <div class="prop-value">
          {{ product?.brand?.name || product?.brand || "—" }}
        </div>
      </div>

      <!-- Category -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.category") }}
        </div>
        <div class="prop-value">
          {{ product?.category?.name || product?.category || "—" }}
        </div>
      </div>

      <!-- Collection -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.collection") }}
        </div>
        <div class="prop-value">
          <span v-if="product?.collections?.length">
            {{ product.collections.join(", ") }}
          </span>
          <span v-else>—</span>
        </div>
      </div>

      <!-- Quantity -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.quantity") }}
        </div>
        <div class="prop-value">
          {{ product?.variants?.[0]?.qty ?? "—" }}
        </div>
      </div>

      <!-- Image URLs -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.imageUrls") }}
        </div>
        <div class="prop-value">
          <span v-if="product?.imageUrl">
            {{ product.imageUrl }}
          </span>
          <span v-else>—</span>
        </div>
      </div>

      <!-- Product URLs -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.productUrls") }}
        </div>
        <div class="prop-value">
          <span v-if="product?.productUrl">
            {{ product.productUrl }}
          </span>
          <span v-else>—</span>
        </div>
      </div>

      <!-- Status -->
      <div class="prop-row">
        <div class="prop-label">
          {{ $t("productPages.productPropertiesModal.status") }}
        </div>
        <div class="prop-value">
          {{ product?.status || "—" }}
        </div>
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal";

export default {
  components: {
    SmallModal,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    modalTitle() {
      return this.$t("productPages.productPropertiesModal.title");
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  @include base-font;
  font-weight: 400;
  margin-bottom: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  min-width: 700px;
  span {
    font-weight: 500;
  }
}
.props-table {
  @include base-font;
  display: grid;
  grid-template-columns: 1fr;
  min-width: 700px;
  border-top: 1px solid $light-grey;
}

.prop-row {
  display: grid;
  grid-template-columns: 220px 1fr;
  align-items: center;
  padding: 16px 14px;
  align-items: center;
  border-bottom: 1px solid $light-grey;
  &:hover {
    background-color: #c4c4c420;
  }
}

.prop-label {
  @include font-normal;
  font-weight: 500;
}

.prop-value {
  @include font-small;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
